/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_TitleInputs */

const cs_messages_title = /** @type {(inputs: Messages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zprávy`)
};

const en_messages_title = /** @type {(inputs: Messages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Messages_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_title = /** @type {((inputs?: Messages_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_title(inputs)
	return cs_messages_title(inputs)
});